import { useEffect } from 'react';
import * as actions from 'actions';
import {useDispatch, useSelector} from "react-redux";
import useRequest from "hooks/useRequest";

const useUser = () => {
    const dispatch = useDispatch();
    const operators = useSelector(state => state.operators);
    const me = useSelector(state => state.me);
    const request = useRequest();

    const init = async () => {
        if(0 === Object.keys(me).length) {
            await fetchMe();
        }
    };

    const fetchUserList=async (project_id)=> {
        const res = await request.post('operator/list', {projectId: project_id});
        dispatch(actions.fetchUsers(res.operators || []));
    };

    const fetchMe=async ()=> {
        const res = await request.post('operator/me');
        dispatch(actions.fetchMe(res.me));
    };

    const create = async (project_id, user) => {
        const res = await request.post('operator/create', {...user, projectId: project_id});
        dispatch(actions.addUser(res.operator));
    };

    const edit = async (user) => {
        const res = await request.post('operator/update', user);
        dispatch(actions.editUser(res.operator));
    };

    const remove=async (user)=> {
        await request.post('operator/delete', user);
        dispatch(actions.deleteUser(user));
    };

    // Owner権限
    // プロジェクトの作成を含む全ての権限を持つ
    // admin@アカウントしか設定しない
    const isOwner=()=> {
        if(!me.profile) return false;

        return me.profile.isOwner;
    };

    // Admin権限
    // プロジェクト作成・編集・削除以外のすべての権限を持つ
    // プロジェクト設定画面で追加する
    const isAdmin=(project_id)=> {
        if(!me.operators) return false;
        const operator = me.operators.find(op=> op.projectId === project_id);
        return operator === null ? false : operator.role === 2;
    };

    // プロジェクトメンバーか（権限は関係ない）
    const isProjectMember=(project_id)=> {
        if(!me.operators) return false;
        return me.operators.findIndex(op=> op.projectId === project_id) >= 0;
    };

    useEffect(() => {
        init();
    },[]);

    return {operators, create, edit, remove, me, fetchUserList, isOwner, isAdmin, isProjectMember};
};

export default useUser;